import type { Locale, Translations } from './index';
import { en as enTranslations } from './translations/en';
import { es as esTranslations } from './translations/es';
import { pt as ptTranslations } from './translations/pt';
import { de as deTranslations } from './translations/de';
import { fr as frTranslations } from './translations/fr';

// The translation dictionaries live in THEIR OWN module so consumers of
// `@/lib/i18n` (types + constants) don't accidentally pull the five
// ~85KB locale files into their client bundle.
//
// Public marketing pages only need `LOCALE_COOKIE`/`DEFAULT_LOCALE` from
// `@/lib/i18n` — importing this map there used to ship all five locales
// in the landing bundle as dead noise (the audit caller saw "ES/PT/DE/FR
// como ruido en /en"). Now anything that actually calls `getTranslations`
// imports from `@/lib/i18n/translations` explicitly, so the dependency is
// visible in the import graph and Webpack can split chunks accordingly.
const _translations: Record<Locale, Translations> = {
    en: enTranslations,
    es: esTranslations,
    pt: ptTranslations,
    de: deTranslations,
    fr: frTranslations,
};

// Synchronous translation lookup — HMR-safe via static imports.
export function getTranslations(locale: Locale): Translations {
    return _translations[locale] ?? _translations.en;
}
